import React from 'react';
import textBg from '../components/image/highLight_border.png'; // 引入背景图片

const TextDisplay = ({ lines, width, height, fontSize }) => {
  // 创建测量元素函数
  const measureTextWidth = (text) => {
    const measurer = document.createElement('span');
    measurer.style.position = 'absolute';
    measurer.style.visibility = 'hidden';
    measurer.style.whiteSpace = 'nowrap';
    measurer.style.fontSize = `${fontSize}px`;
    measurer.textContent = text;
    document.body.appendChild(measurer);
    const textWidth = measurer.offsetWidth;
    document.body.removeChild(measurer);
    return textWidth;
  };

  const containerStyle = {
    width: `${width}px`,
    // overflow: 'hidden'
  };

  const lineContainerStyle = {
    position: 'relative',
    display: 'inline-block',
    marginBottom: '5px' // 行间距
  };

  const textStyle = {
    position: 'relative', // 确保文字在背景图之上
    left: '5px',
    zIndex: 2, // 确保文字显示在背景图上方
    fontSize: `${fontSize}px`,
    lineHeight: '43px',
    whiteSpace: 'nowrap',
    padding: '0 5px', // 文字与背景图的左右间距
    fontWeight: 'bold',
    color: '#313131'
  };

  const backgroundStyle = (textWidth) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: `${textWidth + 10}px`, // 加上padding的宽度
    height: `${height}px`,
    backgroundImage: `url(${textBg})`,
    zIndex: 1,
    backgroundSize: '100% 30px',
    backgroundRepeat: 'no-repeat',
    backgroundPositionY: '128%',
    padding: '0px 6px',
  });

  return (
    <div style={containerStyle}>
      {lines.map((line, index) => {
        const textWidth = measureTextWidth(line);
        return (
          <div key={index} style={lineContainerStyle}>
            <div style={backgroundStyle(textWidth)} />
            <div style={textStyle}>{line}</div>
          </div>
        );
      })}
    </div>
  );
};

TextDisplay.propTypes = {
  lines: React.PropTypes.array.isRequired,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  fontSize: React.PropTypes.number
};

TextDisplay.defaultProps = {
  width: 600,
  height: 50,
  fontSize: 30
};

export default TextDisplay;


// WEBPACK FOOTER //
// src/routes/visualChart/P45/TextDisplay.js